export const Solid = {
  WHITE: '#FFFFFF',
  DARK_WHITE: '#FAFAFA',
  SlateGrey: "#97A2B9",
  LightGrey: "#F9F9F9",
  GREY: '#F4F4F4',
  DARK_GREY: '#797979',
  BORDER_GREY: '#C3CFD9',
  BLACK: '#212121',
  BLUE: '#245EA4',
};

export const Gradient = {
  BLUE: 'linear-gradient(to right, #1E77B4, #2C398D)',
  GREEN: 'linear-gradient(to right, #77DD76, #187B32)',
  ORANGE: 'linear-gradient(to right, #E9B85F, #E18973)',
  GREY: 'linear-gradient(to right, #DADADA, #9D9D9D)',
};

// --------------------------------- NEW // --------------------------------- //

//WHITE
export const textWhite = '#F8F9FA';
export const white = '#fff';
export const bgWhite = '#f0f0f0';

//BLACK
export const lightBlack = '#212121';
export const black = '#252525';
export const bgBlack = '#222';

//BLUE
export const lightBlue = '#448ef6';
// export const lightBlue = '#1e77b4';
export const blue = '#065FD4';
// export const blue = '#245ea4';
export const darkBlue = '#0973FF';
export const bgBlue = '#2196f3';
export const spaceBlue = '#03AEEF';
export const blueMoon = '#003366';

//RED
export const red = '#E34449';
export const brightRed = '#F34D21';

//YELLOW
export const sunrise = '#ffc922';
export const yellowSun = '#ffdb00';
export const brightYellow = '#FEF33E';

//GREY
export const lightGrey = '#f5f7f7';
export const grey = '#39444D';
export const darkGrey = '#444';
// export const bgGrey = '#dfe3e6';
export const bgGrey = '#DFE6ED';
export const borderGrey = '#c3cfd9';
// export const borderGrey = '#39444D';

//GREEN
export const lightGreen = '#25d366';
export const green = '#77DD76';
export const darkGreen = '#1b9849';

// export const primary = '#00c4cc';
export const primary = 'rgba(0, 255, 70, .8)';
export const secondary = '#f39422';
// export const primaryColor = '#1396E7'; //--> VERY GOOOD
// export const primaryColor = '#065FD4';#537ec5 //--> VERY good blue

//MESSAGES COLORS
export const success = "#28a745";
export const info = "#17a2b8";
export const warning = "#ffc107";
export const danger = "#dc3545";



export const backgroundWhite = '#f4f4f4';
// export const lightBlue = '#0ff';



export const brightPurple = '#4444dd';
export const darkTwitterTheme = '#15202B';
export const lightDarkTwitterInputBg = '253341#';
export const fbCopyCatLightTheme = '#F3F4F6';
export const youTubeColorBlue = '#065FD4';
export const flickrBlue = '#1396E7';